import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import SmartHomeHero from './components/SmartHomeHero';
import SmartHomeIntro from './components/SmartHomeIntro';
import AutomationSolutions from './components/AutomationSolutions';
import CentralizedControl from './components/CentralizedControl';
import SmartHomeBenefits from './components/SmartHomeBenefits';
import SmartHomeCTA from './components/SmartHomeCTA';

const SmartHomeServices = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Smart Home Services | Intelligent Living | VASTECH</title>
        <meta
          name="description"
          content="Transform your home into a seamless digital ecosystem with VASTECH's advanced home automation solutions including lighting, climate, security, and entertainment control."
        />
        <meta
          name="keywords"
          content="smart home, home automation, smart lighting, intelligent climate control, home security, smart entertainment, VASTECH automation"
        />
        <meta property="og:title" content="Smart Home Services | VASTECH" />
        <meta
          property="og:description"
          content="Intelligent living through advanced home automation. Integrate your entire home into one seamless digital ecosystem."
        />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://vastech.ae/smart-home-services" />
      </Helmet>

      <div className="min-h-screen bg-white text-slate-900 font-sans selection:bg-accent/30">
        <Header />

        <main className="relative">
          {/* Hero Section */}
          <SmartHomeHero />

          {/* Introduction */}
          <SmartHomeIntro />

          {/* Automation Solutions */}
          <AutomationSolutions />

          {/* Centralized Home Control */}
          <CentralizedControl />

          {/* Benefits Section */}
          <SmartHomeBenefits />

          {/* Final CTA */}
          <SmartHomeCTA />
        </main>

        {/* Minimalistic Footer */}
        <Footer />
      </div>
    </>
  );
};

export default SmartHomeServices;